import { render, staticRenderFns } from "./ViewTag.vue?vue&type=template&id=08471248&"
import script from "./ViewTag.vue?vue&type=script&lang=js&"
export * from "./ViewTag.vue?vue&type=script&lang=js&"
import style0 from "./ViewTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports